module.exports = __webpack_public_path__ + "fa1b702e45128591eb8bd6aa78af3e40.svg";